var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMailCheckLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.008,
    height: 153.01,
    viewBox: "0 0 153.008 153.01",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail_check_illustration",
    "data-name": "mail check_illustration",
    transform: "translate(-26.722 -17.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_388516-PCBNEY-979",
    "data-name": "388516-PCBNEY-979",
    transform: "translate(33.673 25.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M182.053,98.318a76.5,76.5,0,1,0-76.5,76.5,76.5,76.5,0,0,0,76.5-76.5",
    transform: "translate(-35.997 -29.768)",
    fill: "#e2eeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M109.463,68.661l-.53-1.394q1.391-.529,2.779-1.073l.542,1.389q-1.393.543-2.792,1.078",
    transform: "translate(-17.121 -15.189)",
    fill: "#3bb4a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    d: "M147.9,104.466l-51.924,30.62-51.923-30.62.008-.085c.043-.194,2.909-2.587,7.278-6.138l.118-.1C65.8,86.5,95.979,62.661,95.979,62.661S126.16,86.5,140.5,98.141c4.438,3.6,7.356,6.037,7.4,6.239l.008.085",
    transform: "translate(-26.805 -15.716)",
    fill: "#235f86",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    d: "M116.222,40.6H60.2a8.7,8.7,0,0,0-8.7,8.7V134a8.7,8.7,0,0,0,8.7,8.7h70.2a8.7,8.7,0,0,0,8.7-8.7V63.472L116.222,40.6",
    transform: "translate(-25.451 -19.01)",
    fill: "#fffffe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    d: "M107.816,54.772a8.7,8.7,0,0,0,8.7,8.7h14.176L107.816,40.6V54.772",
    transform: "translate(-17.287 -19.01)",
    fill: "#e5e5e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    d: "M111.93,81.438H65.554a2.5,2.5,0,1,0,0,4.995H111.93a2.5,2.5,0,0,0,0-4.995",
    transform: "translate(-23.969 -12.913)",
    fill: "#e5e5e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    d: "M90.868,102.762H65.554a2.5,2.5,0,0,0,0,4.995H90.868a2.5,2.5,0,0,0,0-4.995",
    transform: "translate(-23.969 -19.971)",
    fill: "#e5e5e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M147.908,99.034v49.814a6.343,6.343,0,0,1-6.328,6.327H50.372a6.328,6.328,0,0,1-6.311-6.327V99.034l51.923,30.614,51.924-30.614",
    transform: "translate(-26.804 -10.287)",
    fill: "#2884ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    d: "M145.926,150.5,112.507,117.08l-16.749,9.876L79,117.076,45.58,150.5a6.271,6.271,0,0,0,4.565,1.984h91.208a6.3,6.3,0,0,0,4.573-1.981",
    transform: "translate(-26.577 -7.594)",
    fill: "#136ee8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4964",
    "data-name": "Path 4964",
    d: "M-11537.6,18734.9s6.024-3.555,7.587-2.373,2.794,2.373,4.19,2.373,3.665-1.453,5.061-3.32",
    transform: "translate(11581.047 -18634.209)",
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(39.047 35.791)",
    fill: "#2884ff"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMailCheckLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail_check_logo.6f08602e9defed30cb674e8cbd6042ae.svg";